import { Location } from "react-router-dom";
import { RouteType } from "../@types/RouteType";

export const checkMatchedRoute = (routes: RouteType[], currentLocation: Location, dynamicRoute: boolean): boolean => {

    let foundMatch: boolean = false;

    let currentLocationPath = currentLocation.pathname;

    if (currentLocationPath === '/')
        return true;

    /*
        Remove trailing forward slash if exists
    */
    currentLocationPath = currentLocationPath.replace(/\/+$/, ''); 

    if (dynamicRoute) {

        let routeParts = currentLocationPath.split('/');

        /*
            Remove query parameters portion
        */
        routeParts.pop();

        /*
            Combine together to form route with appended /:id
        */
        currentLocationPath = routeParts.join('/') + '/:id';

    }

    for (const route of routes) {

        /*
            Test against route.path and route.path with an appending forward slash
        */
        if (route.path === currentLocationPath) {

            foundMatch = true;

            return foundMatch;

        }

        if (route.child) {

            for (const routeChild of route.child) {

                if (routeChild.path === currentLocationPath) {

                    foundMatch = true;

                    return foundMatch;

                }

            }

        }

    }

    return foundMatch;

}